import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Clipboard-Text--Streamline-Flex"
    >
        <desc>
            {'Clipboard Text Streamline Icon: https://streamlinehq.com'}
        </desc>
        <g id="clipboard-text--edition-form-task-checklist-edit-clipboard">
            <path
                id="Subtract"
                stroke="currentColor"
                d="M4.17349 2.10889c-0.25729 0.02946 -0.60252 0.06018 -0.85608 0.09067 -0.24071 0.02894 -0.47967 0.05767 -0.71681 0.08492 -0.49602 0.05701 -0.88913 0.44564 -0.92587 0.93465 -0.23427 3.11835 -0.23427 6.06189 0 9.18027 0.03674 0.489 0.43009 0.8788 0.92783 0.9188 3.02054 0.2425 5.77459 0.2425 8.79514 0 0.4977 -0.04 0.8911 -0.4298 0.9278 -0.9188 0.2343 -3.11838 0.2343 -6.06192 0 -9.18027 -0.0367 -0.48901 -0.4298 -0.87764 -0.9259 -0.93465 -0.2371 -0.02725 -0.4761 -0.05598 -0.7168 -0.08492 -0.2535 -0.03049 -0.6081 -0.06121 -0.86532 -0.09067"
                strokeWidth={1}
            />
            <path
                id="Union"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.3045 0.54519c0.97879 0.037253 1.52665 0.52425 1.52665 1.36417 0 0.83991 -0.54786 1.3269 -1.52665 1.36416 -1.58314 0.06025 -1.02528 0.06025 -2.60842 0 -0.97879 -0.03726 -1.52665 -0.52425 -1.52665 -1.36416 0 -0.83992 0.54786 -1.326918 1.52665 -1.36417 1.58314 -0.060253 1.02528 -0.060253 2.60842 0Z"
                strokeWidth={1}
            />
            <path
                id="Vector 106"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.63147 6.51001h4.73706"
                strokeWidth={1}
            />
            <path
                id="Vector 107"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.63147 9.16626h2.85857"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
